export interface HelpCase {
  id: string;
  name: string;
  subTitle?: string;
  image: string;
  imageAlt?: string;
  newBadge?: boolean;
}

export interface HelpPage {
  header?: string;
  cases?: HelpCase[];
  url?: string;
}

export enum HelpCaseId {
  ACADEMY = 'academy',
  ARTICLES = 'articles',
  BOOK_MEETING = 'bookMeeting',
  CALL_US = 'callUs',
  COMMUNITY = 'community',
  CONTACT_US = 'contactUs',
  LIVE_CHAT = 'liveChat',
  MAIN = 'main',
  SEARCH = 'search',
  SUBMIT_TICKET = 'submitTicket',
  TICKET_HISTORY = 'ticketHistory',
  CANNY = 'canny',
}

export const HELP_CASES: { [helpCaseId: string]: HelpCase } = {
  academy: {
    id: HelpCaseId.ACADEMY,
    name: 'HELP_CENTER.CASES.ACADEMY',
    image: '/images/help-center/academy.svg',
    imageAlt: 'Academy',
  },
  articles: {
    id: HelpCaseId.ARTICLES,
    name: 'HELP_CENTER.CASES.ARTICLES',
    image: '/images/help-center/article.svg',
    imageAlt: 'Articles',
  },
  bookMeeting: {
    id: HelpCaseId.BOOK_MEETING,
    name: 'HELP_CENTER.CASES.BOOK_MEETING',
    image: '/images/help-center/bookMeet.svg',
    imageAlt: 'Book meeting',
  },
  callUs: {
    id: HelpCaseId.CALL_US,
    name: 'HELP_CENTER.CASES.CALL_US',
    image: '/images/help-center/callUs.svg',
    imageAlt: 'Call us',
  },
  community: {
    id: HelpCaseId.COMMUNITY,
    name: 'HELP_CENTER.CASES.COMMUNITY',
    image: '/images/help-center/globe.svg',
    imageAlt: 'Community',
  },
  contactUs: {
    id: HelpCaseId.CONTACT_US,
    name: 'HELP_CENTER.CASES.CONTACT_US',
    image: '/images/help-center/contactUs.svg',
    imageAlt: 'Contact us',
  },
  liveChat: {
    id: HelpCaseId.LIVE_CHAT,
    name: 'HELP_CENTER.CASES.LIVE_CHAT',
    image: '/images/help-center/liveChat.svg',
    imageAlt: 'Live chat',
  },
  submitTicket: {
    id: HelpCaseId.SUBMIT_TICKET,
    name: 'HELP_CENTER.CASES.SUBMIT_TICKET',
    image: '/images/help-center/ticket.svg',
    imageAlt: 'Submit ticket',
  },
  ticketHistory: {
    id: HelpCaseId.TICKET_HISTORY,
    name: 'HELP_CENTER.CASES.TICKET_HISTORY',
    image: '/images/help-center/ticketHistory.svg',
    imageAlt: 'Ticket history',
  },
  canny: {
    id: HelpCaseId.CANNY,
    name: 'HELP_CENTER.CASES.CANNY.TITLE',
    image: '/images/help-center/map.svg',
    imageAlt: 'View our roadmap',
  },
};

export const HELP_PAGES: { [caseId: string]: HelpPage } = {
  main: {
    header: 'HELP_CENTER.HEADERS.MAIN',
    cases: [
      HELP_CASES[HelpCaseId.ACADEMY],
      HELP_CASES[HelpCaseId.ARTICLES],
      HELP_CASES[HelpCaseId.COMMUNITY],
      HELP_CASES[HelpCaseId.CANNY],
      HELP_CASES[HelpCaseId.SUBMIT_TICKET],
      HELP_CASES[HelpCaseId.TICKET_HISTORY],
    ],
  },
  academy: {
    url: 'https://academy.vendasta.com/home/content/all',
  },
  community: {
    url: 'https://www.facebook.com/groups/vendasta',
  },
  articles: {
    url: 'https://support.vendasta.com',
  },
  submitTicket: {
    url: 'https://support.vendasta.com/hc/en-us/requests/new',
  },
  ticketHistory: {
    url: 'https://support.vendasta.com/hc/en-us/requests',
  },
};
